import {
  ApolloClient,
  createHttpLink,
  from,
  InMemoryCache,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { apiConfig } from "./config";
import { getOrg } from "./src/utils/site";
import { inBrowser } from "./src/utils/env";

const httpLink = createHttpLink({
  uri: apiConfig.GRAPHQL_ENDPOINT,
});

const authLink = setContext(async (_, { headers }) => {
  let token = "";
  let openidToken = "";

  if (inBrowser) {
    token = sessionStorage.getItem("token") ?? "";
    openidToken = sessionStorage.getItem("openidToken") ?? "";
  }

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
      "x-openid-auth": openidToken ? `Bearer ${openidToken}` : "",
      "x-org": getOrg(),
    },
  };
});
const client = new ApolloClient({
  cache: new InMemoryCache({
    typePolicies: {
      KennelPolicy: {
        fields: {
          metadata: {
            merge(existing, incoming, { mergeObjects }) {
              return mergeObjects(existing, incoming);
            },
          },
        },
      },
      KennelClient: {
        fields: {
          metadata: {
            merge(existing, incoming, { mergeObjects }) {
              return mergeObjects(existing, incoming);
            },
          },
        },
      },
      KennelFee: {
        keyFields: ["name", "total"],
      },
      // Slug identifies a product within an org, and a client only ever talks
      // to one. Without a key the products are stored inline under the
      // `appProducts` root field, so two queries selecting different fields of
      // it replace each other's array wholesale rather than merging — the
      // signup's catalogue prefetch would blank the fields the pricing query
      // needs. Keyed, they write disjoint fields onto the same entity.
      AppProduct: {
        keyFields: ["slug"],
      },
      DraftPreview: {
        fields: {
          policyPreviews: {
            merge(_existing, incoming) {
              return incoming;
            },
          },
        },
      },
      Query: {
        fields: {
          userPaymentPolicies: {
            merge(_existing, incoming) {
              return incoming;
            },
          },
          paymentPolicies: {
            merge(_existing, incoming) {
              return incoming;
            },
          },
        },
      },
    },
  }),
  link: from([authLink, httpLink]),
});

export default client;
